<template>
  <div>
    <img class="background-img col-12 cover h100" src="../assets/space.jpg">

    <cql-headerbar/>


    <!-- CREATING NEW PROJECT -->
    <div class="lightbox" v-if="createNewModal">
        <div class="lightbox-box flex-column bg-color-darkgray p3 rounded-border max-width-3 mt4 ui-modal--settings col-12">
            <button class="lightbox-close-btn" @click="createNewModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">{{$t('project-overview_h_neues_projekt_erstellen')}}</h2>
            <div class=" row-sys flex align-middle col-12 mb1">
              <p class="col-3 small white  ">{{$t('project_overview_creation_modal_name')}}</p>
              <input class="user-input-narrow col-8 border-box" :placeholder="$t('project_overview_creation_modal_name_placeholder')" v-model="createNewModal_newProjectName">
            </div>
            <div class=" row-sys flex align-middle col-12 mb1">
              <p class="col-3 small white  ">{{$t('project_overview_creation_modal_place')}}</p>
              <input class="user-input-narrow col-8 border-box" :placeholder="$t('project_overview_creation_modal_place_placeholder')" v-model="createNewModal_newProjectDescription">
            </div>
            <div class="flex justify-end col-11">
              <a class="btn btn-small self-end" @click="createNewObj()">{{$t('project-overview_btn_ok')}}</a>
            </div>
        </div>
    </div>

    <!-- EDITING EXISTING PROJECT -->
    <div class="lightbox" v-if="openProjectEditModal">
        <div class="lightbox-box flex-column bg-color-darkgray p3 rounded-border max-width-3 mt4 ui-modal--settings col-12">
            <button class="lightbox-close-btn" @click="openProjectEditModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 class="h3 white regular center mb4">{{$t('project-overview_h_projekt_bearbeiten')}}</h2>
            <div class=" row-sys flex align-middle col-12 mb1">
              <p class="col-3 small white  ">{{$t('project_overview_update_modal_name')}}</p>
              <input class="user-input-narrow col-8 border-box" :placeholder="$t('project_overview_update_modal_name_placeholder')" v-model="editProjectTitle">
            </div>
            <div class=" row-sys flex align-middle col-12 mb1">
              <p class="col-3 small white  ">{{$t('project_overview_update_modal_place_placeholder')}}</p>
              <input class="user-input-narrow col-8 border-box" :placeholder="$t('project_overview_update_modal_place_placeholder')" v-model="editProjectDescription">
            </div>
            <div class="flex justify-end col-11">
            <a class="btn btn-small self-end" @click="editObj()">{{$t('project-overview_btn_ok')}}</a>
            </div>
        </div>
    </div>

    <!-- DELETE PROJECT -->
    <div class="lightbox" v-show="showDeletionPopupModal">
        <div class="lightbox-box flex-column bg-color-darkgray p3 rounded-border max-width-3 mt4">
            <button class="lightbox-close-btn" @click="showDeletionPopupModal = false">
                <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <h2 v-if="projectToBeDeleted.calcCount == 0" class="h3 white regular center mb4">{{$t('project-overview_deletion_popup_wirklich_loeschen_part_1')}}{{projectToBeDeleted.name}}{{$t('project-overview_deletion_popup_wirklich_loeschen_part_2')}}</h2>
            <h2 v-if="projectToBeDeleted.calcCount == 1" class="h3 white regular center mb4">{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_1')}}{{projectToBeDeleted.name}}{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_2_case_2')}}{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_3_case_2')}}</h2>
            <h2 v-if="projectToBeDeleted.calcCount > 1" class="h3 white regular center mb4">{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_1')}}{{projectToBeDeleted.name}}{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_2')}}{{projectToBeDeleted.calcCount}}{{$t('project-overview_deletion_popup_wirklich_loeschen_and_calcs_part_3')}}</h2>
            <div class="flex align-middle justify-center">
              <div>
                <a class="btn btn-small btn-bg-red mr3" @click="showDeletionPopupModal = false, projectToBeDeleted = ''">{{$t('project-overview_deletion_popup_decline')}}</a>
              </div>
              <div>
                <a class="btn btn-small" @click="deleteProject()">{{$t('project-overview_deletion_popup_accept')}}</a>
              </div>
            </div>
        </div>
    </div>


    <!-- <div class="col-12 flex flex-end px4 pt4 border-box">
      <div class="flex align-middle pointer" v-on:click="newProjectModal()">
        <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="white p-small ml1 mr4">{{$t('project-overview_p_neues_projekt')}}</p>
      </div>

      <div class="flex align-middle pointer">
        <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
          <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.247 5.25H21.747C22.5755 5.25 23.247 5.92157 23.247 6.75V21.75C23.247 22.5784 22.5755 23.25 21.747 23.25H8.24704C7.41861 23.25 6.74704 22.5784 6.74704 21.75V15.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.747 9.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.497 14.25H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 18.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25004 9.75V6.75L12.439 2.561C12.7423 2.25756 12.833 1.80138 12.6688 1.40504C12.5047 1.0087 12.118 0.750194 11.689 0.75H1.81104C1.38205 0.750194 0.995395 1.0087 0.831256 1.40504C0.667117 1.80138 0.757798 2.25756 1.06104 2.561L5.25004 6.75V12.75L8.25004 9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="white p-small ml1">{{$t('project-overview_p_filter')}}</p>
      </div>
    </div> -->

    <div class="px4">
      <div class="ui-navbar flex align-middle ml2 mb3 mt2 justify-between">
        <div class="flex align-middle">        
          <div class="house-button">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5 8.4V3.5C20.5 3.22385 20.2761 3 20 3H18C17.7239 3 17.5 3.22385 17.5 3.5V5.64L13.338 1.811C13.1465 1.63437 12.8515 1.63437 12.66 1.811L1.66001 12.132C1.50816 12.2717 1.45769 12.4903 1.53294 12.6824C1.60818 12.8745 1.79369 13.0006 2.00001 13H4.50001V22.5C4.50001 23.0523 4.94772 23.5 5.50001 23.5H20.5C21.0523 23.5 21.5 23.0523 21.5 22.5V13H24C24.2061 13.0002 24.3913 12.8739 24.4663 12.6819C24.5412 12.4899 24.4907 12.2715 24.339 12.132L20.5 8.4Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="flex align-baseline">
            <h3 class="white h3 regular mx2">{{$t('project-overview_projects')}}</h3>
          </div>
        </div>
        <div class="flex px4 border-box">
          <div class="flex align-middle pointer" v-on:click="newProjectModal()">
            <div class="bg-color-cta p1 relative" style="border-radius: 30px; height:30px; width:30px">
              <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="white p-small ml1 mr4">{{$t('project-overview_p_neues_projekt')}}</p>
          </div>
          <!-- <div class="flex align-middle pointer">
            <div class="bg-color-cta  p1 relative" style="border-radius: 30px; height:30px; width:30px">
              <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.247 5.25H21.747C22.5755 5.25 23.247 5.92157 23.247 6.75V21.75C23.247 22.5784 22.5755 23.25 21.747 23.25H8.24704C7.41861 23.25 6.74704 22.5784 6.74704 21.75V15.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.747 9.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.497 14.25H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 18.75H20.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25004 9.75V6.75L12.439 2.561C12.7423 2.25756 12.833 1.80138 12.6688 1.40504C12.5047 1.0087 12.118 0.750194 11.689 0.75H1.81104C1.38205 0.750194 0.995395 1.0087 0.831256 1.40504C0.667117 1.80138 0.757798 2.25756 1.06104 2.561L5.25004 6.75V12.75L8.25004 9.75Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="white p-small ml1">{{$t('project-overview_p_filter')}}</p>
          </div> -->
        </div>
      </div>
      <div class="flex flex-wrap max-width-7 op0" style=" transition: opacity .3s ease .3s;" :class="{op100: projects.length !== 0, absolute: projects.length !== 0}">
        <project-card 
          v-for="project in projects"
          :key="project.id"
          :id="project.id"
          :title="project.title"
          :subtitle="project.subtitle"
          :lastChanged="project.lastChanged"
          :jobCount="project.jobCount"
          :calcCount="project.calcCount"
        />
      </div>
      <div class="ml2 pt4 op0 absolute" style="transition: opacity .3s ease .3s;" :class="{op100: fetchedProjects == true && projects.length == 0, npe: fetchedProjects == true && projects.length !== 0 }">
        <h2 class="h1 light white mb2">{{$t('project-overview_h_projekt_nicht_vorhanden')}}</h2>
        <button class="btn btn-primary" v-on:click="newProjectModal()">{{$t('project-overview_btn_projekt_erstellen')}}</button>
      </div>
      <div class="synchronising-box bg-color-darkgray px4 py3 max-width-1 mx-auto flex flex-column justify-center drop-shadow rounded-border" :class="{hidden: fetchedProjects == true}" style="z-index: 9999;">
        <div class="flex justify-center mb3">
        <img src="../assets/cql_logo.svg" style="width: 100px;">
        </div>
        <div class="mx-auto mt3 mb3 spinning relative">
          <svg class="synchro-arrows" width="70" height="70" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.7496 19.9889L28.8755 14.5788L25.0479 20.773" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M28.8505 14.6473C30.8379 22.2118 26.3273 29.9576 18.7673 31.9624" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.64827 1L5.92969 7.75154L13.1731 8.47289" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.94922 7.73741C11.8941 2.63272 20.8455 3.28748 25.9843 9.2029" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.43481 33L10.6383 31.9465L7.60463 25.3261" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5395 31.8865C3.15258 29.3364 -0.770083 21.2824 1.77646 13.8943" stroke="#FBBC05" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h4 class="h4 regular white center mt3">{{$t('project-overview_h_synchronisiere')}}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import cqlHeaderbar from './cqlHeaderbar.vue';


import ProjectCard from './ProjectCard.vue';

import { EventBus } from "../event-bus";
import axios from 'axios'

export default {
  name: "ProjectsOverview",
  data() {
    return {
      showDeletionPopupModal: false,
      projectToBeDeleted: '',
      projects: [
        
      ],
      fetchedProjects: null,
      createNewModal: false,
      createNewModal_newProjectName: '',
      createNewModal_newProjectDescription: '',

      openProjectEditModal: false,
      editProjectTitle: '',
      editProjectDescription: '',
      editProjectId: '',

      componentInited: false
    };
  },
  created: function () {
    if(this.componentInited == false) {
      console.log('this.componentInited: false!');
      EventBus.$on('loginSuccessful', (payload) => {
        this.userdata = payload.userdata;
        this.session = payload.session;
        this.loginStatus = true;
      });
      EventBus.$on('loginSuccessfulSubComponents', (payload) => {
        this.userdata = payload.userdata;
        this.username = payload.userdata.company  + " " + payload.userdata.firstname + " " + payload.userdata.name;
        this.session = payload.session;
        this.loginStatus = true;

        this.loadProjectsList();

      });
      EventBus.$on('cloneProject', (payload) => {
        this.fetchedProjects = false; // Settings to false shows loading...
        console.log('clone called...');
       //let currentObj = this;
        let data = {projectid: payload.id};
        let merged = {...data, ...this.session};
        axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/clone/json', merged)
          .then(
            
            this.loadProjectsList()
          
          );
      });
      EventBus.$on('removeProjectPopup', (payload) => {
        this.showDeletionPopupModal = true;
        this.projectToBeDeleted = payload;
      })
   

      EventBus.$on('editProjectSettings', (payload) => {
        this.openProjectEditModal = true
        this.editProjectTitle = payload.title
        this.editProjectDescription = payload.subtitle
        this.editProjectId = payload.id
      });

      EventBus.$on('loginNotCorrect', () => {
        this.$router.push({ path:'/' + this.$il8n.locale + '/logout-session'});
      });

      this.componentInited = true;
      console.log('this.componentInited: set to true!');

    } 
  },
  beforeDestroy() {
      EventBus.$off('cloneProject');
      EventBus.$off('removeProjectPopup');
      EventBus.$off('editProjectSettings');
  },
  mounted: function () {
    EventBus.$emit('loginCheckQaL', {
    });
  },
  methods: {
   loadProjectsList() {
     console.log('load_projects list')
      let url = process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-list/json';
      let currentObj = this;
      axios.post(url, this.session)
      .then(response => {
        currentObj.projects = response.data.projects;
          currentObj.fetchedProjects = true
      })
      .catch(function () {
        currentObj.log('catch Function of AJAX-Called... error()');
      });

    },
    newProjectModal() {
        this.createNewModal = true;
    },
    createNewObj() {
      let currentObj = this;
      let data = {};
      data.name = this.createNewModal_newProjectName;
      data.description = this.createNewModal_newProjectDescription;
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/add/json', merged)
          .then(function () {
            currentObj.loadProjectsList(); 
            currentObj.createNewModal = false;
            currentObj.createNewModal_newProjectName = '';
            currentObj.createNewModal_newProjectDescription = '';
          });
    },
    editObj(){
      let currentObj = this;
      let data = {};
      console.log(data)
      data.title = this.editProjectTitle;
      data.description = this.editProjectDescription;
      data.projectid = this.editProjectId;
      let merged = {...data, ...this.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/update/json', merged).then(function () {
        
        currentObj.loadProjectsList(); currentObj.openProjectEditModal = false;
        
        }  );
    },
    deleteProject(){
      this.fetchedProjects = false;
      console.log('delete project...');
      let currentObj = this;
      let data = {projectid: this.projectToBeDeleted.id};
      let merged = {...data, ...currentObj.session};
      axios.post(process.env.VUE_APP_APIENDPOINT + '/quickandlightapp/project-actions/remove/json', merged)
        .then(function () {
          console.log('than.delete project...');
          currentObj.fetchedProjects = true;
          currentObj.loadProjectsList();
          
        });
      this.showDeletionPopupModal = false;
      this.projectToBeDeleted = {};
    }
  },
  components: {
    'project-card': ProjectCard,
    'cql-headerbar':cqlHeaderbar,
  },

};
</script>
<style scoped>
</style>
